<template>
    <div class="layout">
        <main class="main" role="main">
            <slot />
        </main>
    </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
    name: 'Default',
    computed: {
        ...mapState({
            theme: state => state.theme,
        }),
    },
};
</script>

<style lang="scss" scoped>
.layout {
    min-height: 100vh;
    display: flex;
    flex-direction: column;
}
</style>
